export enum LanguageKey {
    Es = 'ES',
    En = 'EN'
}
